export const NO_SCROLL_CLASS = 'no-scroll'
